var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"pagination":false},scopedSlots:_vm._u([{key:"expandedRowRender",fn:function(record){return _c('p',{staticStyle:{"margin":"0"}},[_vm._v("\n    "+_vm._s(record.description)+"\n  ")])}}])})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f6cc6e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/default.vue
// module id = null
// module chunks = 